import Vue from 'vue';
import buildApiQuery from '@/lib/buildApiQuery';
import isEqual from 'lodash/isEqual';
import nonreactive from '@/lib/nonreactive';
import handleErrors from '@/lib/handleErrors';

const moduleState = {
  stations: [],
  geojson: {
    type: 'FeatureCollection',
    features: [],
  },
  searchLocationCountry: null,
  searchLocationsGeojson: {
    type: 'FeatureCollection',
    features: [],
  },
  total: null,
  currentApiQuery: {},
  nearestError: null,
};

const moduleGetters = {
  nearestStations: (state) => state.stations,
  nearestStationsGeojson: (state) => state.geojson,
  nearestStationsSearchLocationCountry: (state) => state.searchLocationCountry,
  nearestStationsSearchLocationsGeojson: (state) => state.searchLocationsGeojson,
  nearestStationsTotal: (state) => state.total,
  getNearestError: (state) => state.nearestError,
};

const mutations = {
  saveNearestCurrentApiQuery(state, apiQuery) {
    state.currentApiQuery = apiQuery;
  },

  saveNearestStations(state, payload) {
    const geojson = {
      type: 'FeatureCollection',
      features: [],
    };

    const searchLocationsGeojson = {
      type: 'FeatureCollection',
      features: [],
    };

    if (payload && payload.data && payload.data.fuel_stations) {
      state.stations = nonreactive.frozen(payload.data.fuel_stations);
      state.total = payload.data.total_results;
      state.searchLocationCountry = payload.data.location_country;

      searchLocationsGeojson.features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [payload.data.longitude, payload.data.latitude],
        },
        properties: {
          color: 'red',
        },
      });

      for (let index = 0, len = payload.data.fuel_stations.length; index < len; index += 1) {
        const station = payload.data.fuel_stations[index];
        geojson.features.push({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [station.longitude, station.latitude],
          },
          properties: {
            id: station.id,
            fuel: station.fuel_type_code,
            index,
          },
        });
      }
    } else {
      state.stations = [];
      state.total = null;
      state.searchLocationCountry = null;
    }

    state.geojson = nonreactive.frozen(geojson);
    state.searchLocationsGeojson = nonreactive.frozen(searchLocationsGeojson);

    if (payload) {
      state.currentApiQuery = payload.apiQuery;
    }
  },

  setNearestError(state, status) {
    state.nearestError = status;
  },
};

const actions = {
  async fetchNearestStations({ commit, state, getters }, query) {
    try {
      const apiQuery = {
        ...buildApiQuery(getters, query),
        location: query.location,
        radius: 'infinite',
        limit: '10',
      };
      if (isEqual(apiQuery, state.currentApiQuery)) {
        return;
      }

      commit('setLoadingNearestStations', true);
      commit('saveNearestCurrentApiQuery', apiQuery);

      // If the location is empty, then return an empty result without
      // actually performing an ajax query.
      if (apiQuery.location === undefined || apiQuery.location === null || apiQuery.location === '') {
        commit('saveNearestStations', {
          apiQuery,
        });
        commit('setLoadingNearestStations', false);
        return;
      }

      const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL_ROOT}/v1/nearest.json`, {
        params: apiQuery,
      });
      commit('saveNearestStations', {
        apiQuery,
        data: response.data,
      });
      commit('setNearestError', null);
    } catch (e) {
      commit('saveNearestStations');
      commit('setNearestError', handleErrors(e));
    } finally {
      commit('setLoadingNearestStations', false);
    }
  },
};

export default {
  state: moduleState,
  getters: moduleGetters,
  mutations,
  actions,
};
